import React from 'react';
import {useParams} from 'react-router-dom';
import EventsListView from '@/views/events/EventsListView';


interface CustomerCallsListViewProps {
  customerId?: string;
}

const CustomerCallsListView: React.FC<CustomerCallsListViewProps> = React.memo(({customerId}) => {
    const urlParams = useParams();
    const customerIdToUse = customerId || urlParams.customerId;
    
    return (
        <div>
            <EventsListView 
                activeObjectType="customer" 
                activeObject={customerIdToUse || '0'} 
            />
        </div>
    );
});

export default CustomerCallsListView;
